export const thumb = (id, w = 600) => `https://drive.google.com/thumbnail?id=${id}&sz=w${w}`;
export const preview = (id) => `https://drive.google.com/file/d/${id}/preview`;
